import {
  getToken,
  setToken,
  getUSERINFO,
  setUSERINFO,
  setUserAliyun,
  getUserAliyun,
  getSYSTEMINFO,
  setSYSTEMINFO
} from '../cookies'
import { login, PostToken, PostAskLogin } from '@/api/loginApi'
import { routes } from '@/router'
import Layout from '@/views/index/layout.vue'
import BigScreen from '@/BigScreen.vue'
// 菜单模块状态库
const state = {
  // 是否收起菜单
  isCollapse: JSON.parse(sessionStorage.getItem('isCollapse')) || false,
  // token 令牌
  Token: getToken() || '',
  // 用户信息
  USERINFO: getUSERINFO() || {},
  // 后台返回的路由
  ArrJurisdiction: JSON.parse(sessionStorage.getItem('ArrJurisdiction')) || [],
  // 默认路由
  DEFAUTROUTERS: routes,
  // 追加的路由
  ASYNCROUTERS: [],
  // 所有的路由
  ALLROUTERS: [],
  // 按钮权限 拥有那些按钮
  BUTTONS: JSON.parse(sessionStorage.getItem('BUTTONS')) || [],
  // 阿里云信息
  USERALIYUN: getUserAliyun() || {},
  // 系统信息
  SYSTEMINFO: getSYSTEMINFO() || {}
}

const getters = {
  getIsCollapse: (state) => state.isCollapse,
  getToken: (state) => state.Token,
  getUSERINFO: (state) => state.USERINFO,
  getSYSTEMINFO: (state) => state.SYSTEMINFO,
  getUserAliyun: (state) => state.USERALIYUN,
  getDEFAUTROUTERS: (state) => state.DEFAUTROUTERS,
  getASYNCROUTERS: (state) => state.ASYNCROUTERS,
  getBUTTONS: (state) => state.BUTTONS,
  getArrJurisdiction: (state) => state.ArrJurisdiction,
  getALLROUTERS: (state) => state.ALLROUTERS
}

const mutations = {
  setIsCollapse(state, isCollapse) {
    state.isCollapse = isCollapse
    sessionStorage.setItem('isCollapse', JSON.stringify(state.isCollapse))
  },
  setToken(state, Token) {
    state.Token = Token
  },
  setUSERINFO(state, USERINFO) {
    state.USERINFO = USERINFO
  },
  setSYSTEMINFO(state, SYSTEMINFO) {
    state.SYSTEMINFO = SYSTEMINFO
  },
  setUserAliyun(state, USERALIYUN) {
    state.USERALIYUN = USERALIYUN
  },
  removeUSERINFO(state) {
    state.USERINFO = {}
  },
  removeSYSTEMINFO(state) {
    state.SYSTEMINFO = {}
  },
  removeToken(state) {
    state.Token = ''
  },
  setROUTERS(state, ASYNCROUTERS) {
    state.ASYNCROUTERS = ASYNCROUTERS
    state.ALLROUTERS = state.DEFAUTROUTERS.concat(state.ASYNCROUTERS)
  },
  setBUTTONS(state, BUTTONS) {
    state.BUTTONS = BUTTONS
    sessionStorage.setItem('BUTTONS', JSON.stringify(BUTTONS))
  },
  removeBUTTONS(state) {
    state.BUTTONS = []
    sessionStorage.setItem('BUTTONS', JSON.stringify([]))
  },
  setArrJurisdiction(state, ArrJurisdiction) {
    state.ArrJurisdiction = ArrJurisdiction
    sessionStorage.setItem('ArrJurisdiction', JSON.stringify(ArrJurisdiction))
  },
  removeArrJurisdiction(state) {
    state.ArrJurisdiction = []
    sessionStorage.removeItem('ArrJurisdiction')
  },
  removeASYNCROUTERS(state) {
    state.ASYNCROUTERS = []
  },
  removeALLROUTERS(state) {
    state.ALLROUTERS = []
  }
}

const actions = {
  /**
   * 登录获取基本需要信息
   * res.data.token_type
   * res.data.refresh_token
   * res.data.expires_in
   * res.data.scope
   * @param {*} param0
   * @param {*} reqData
   */
  loginStore({ commit, dispatch }, reqData) {
    return new Promise((resolve, reject) => {
      PostToken(reqData).then(resToken => {
        commit('setToken', resToken.data.access_token)
        setToken(resToken.data.access_token)

        login(reqData).then((res) => {
          if (res.data.code !== '0000') {
            return reject(res)
          }
          if (res.data.info.functionList.length === 0) {
            return reject(res)
          }

          const data = res.data.info
          setUSERINFO(JSON.stringify(data.userDetail))
          commit('setUSERINFO', JSON.stringify(data.userDetail))

          setSYSTEMINFO(JSON.stringify(data.systemLogInfo))
          commit('setSYSTEMINFO', JSON.stringify(data.systemLogInfo))

          setUserAliyun(JSON.stringify(data.userAliyun))
          commit('setUserAliyun', JSON.stringify(data.userAliyun))

          commit('setArrJurisdiction', data.functionList)
          resolve()
        }).catch((err) => {
          reject(err)
        })
      }).catch((err) => {
        reject(err)
      })
    })
  },
  /** A系统(business-pc)外链跳入：用地址栏ask票据换取本系统登录态 */
  askLoginStore({ commit }, { ask }) {
    return new Promise((resolve, reject) => {
      PostAskLogin({ token: ask }).then((res) => {
        const body = res && res.data
        // 该接口是 code:200 + msg 口径，全局拦截器只认 0000，业务失败只能在这里判
        if (!body) {
          return reject(new Error('外链登录无响应，请稍后重试'))
        }
        if (Number(body.code) !== 200) {
          return reject(new Error(body.msg || '外链登录失败，请重新登录'))
        }
        const info = body.data || {}
        if (!info.accessToken) {
          return reject(new Error('外链登录未返回访问令牌'))
        }
        const functionList = info.functionList || []
        if (functionList.length === 0) {
          return reject(new Error('该账号未配置任何功能权限，请联系管理员'))
        }
        // ask登录只渲染大屏：菜单树取 functionId 为 BigScreen 的那一项
        const bigScreen = functionList.find((item) => item.functionId === 'BigScreen')
        if (!bigScreen) {
          return reject(new Error('该账号未配置大屏权限，请联系管理员'))
        }

        commit('setToken', info.accessToken)
        setToken(info.accessToken)

        // 兜底空对象：JSON.stringify(undefined)不是字符串，cookie会写成字面量"undefined"，下游JSON.parse直接抛
        setUSERINFO(JSON.stringify(info.userDetail || {}))
        commit('setUSERINFO', JSON.stringify(info.userDetail || {}))

        setSYSTEMINFO(JSON.stringify(info.systemLogInfo || {}))
        commit('setSYSTEMINFO', JSON.stringify(info.systemLogInfo || {}))

        setUserAliyun(JSON.stringify(info.userAliyun || {}))
        commit('setUserAliyun', JSON.stringify(info.userAliyun || {}))

        commit('setArrJurisdiction', [bigScreen])

        // 落地到大屏第一个子菜单：BigScreen父路由只有router-view，停上去是白屏
        const pages = bigScreen.children || []
        const firstMenu = pages.find((item) => item.status !== '1') || pages[0]
        resolve(firstMenu ? `/${firstMenu.functionId}` : '/BigScreen')
      }).catch((err) => {
        reject(err)
      })
    })
  },
  dynamicAddRouter({ commit, state }, ArrJurisdiction) {
    return new Promise((resolve, reject) => {
      // 所有菜单
      const joint = []
      const buttons = []
      for (let i = 0; i < ArrJurisdiction.length; i++) {
        if (ArrJurisdiction[i].functionId === 'Wechat_permission') {
          continue
        }
        const asyncRoutersModule = {}
        asyncRoutersModule['path'] = `/${ArrJurisdiction[i].functionId}`
        asyncRoutersModule['name'] = `${ArrJurisdiction[i].functionId}Page`
        asyncRoutersModule['meta'] = {}
        asyncRoutersModule.meta['name'] = ArrJurisdiction[i].functionName
        asyncRoutersModule.meta['icon'] = ArrJurisdiction[i].functionIcon
        if (ArrJurisdiction[i].functionId === 'BigScreen') {
          asyncRoutersModule['component'] = BigScreen
        } else {
          asyncRoutersModule['component'] = Layout
        }

        asyncRoutersModule['children'] = []
        // 顶层功能可能没有子项(children为null，如home)，直接取.length会抛TypeError
        for (let j = 0; j < (ArrJurisdiction[i].children || []).length; j++) {
          const asyncRouterPagesModule = {}
          asyncRouterPagesModule['path'] = `/${ArrJurisdiction[i].children[j].functionId}`
          asyncRouterPagesModule['name'] = `${ArrJurisdiction[i].children[j].functionId}Page`
          if (ArrJurisdiction[i].children[j].status === '1') {
            asyncRouterPagesModule['hidden'] = true
          }
          asyncRouterPagesModule['meta'] = {}
          asyncRouterPagesModule.meta['name'] = ArrJurisdiction[i].children[j].functionName
          asyncRouterPagesModule.meta['icon'] = ArrJurisdiction[i].children[j].functionIcon
          let pagePath = ArrJurisdiction[i].children[j].path
          // 演示模式（--mode demo）：统计页加载本地演示版 local.vue
          if (process.env.VUE_APP_DEMO === 'true' && /bigscreen\/ruijin\/statistics/.test(pagePath)) {
            pagePath = 'bigscreen/ruijin/statistics/local.vue'
          }
          const component = (resolve) =>
            require([`@/views/${pagePath}`], resolve)
          asyncRouterPagesModule['component'] = component
          asyncRoutersModule.children.push(asyncRouterPagesModule)
          // 叶子节点的children同样可能为null
          const btnTemp = (ArrJurisdiction[i].children[j].children || []).filter((item) => {
            return item.functionId
          })
          btnTemp.forEach(item => {
            buttons.push(
              item.functionId
            )
          })
        }
        joint.push(asyncRoutersModule)
      }
      commit('setBUTTONS', buttons)
      commit('setROUTERS', joint)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
